import './calendar-side-bar.style.sass';
import template from './calendar-side-bar.tpl.pug';

class CalendarSideBarController {
    close() {
        return this.onClose();
    }
}

export default {
    selector: 'dbACalendarSideBar',
    template: template(),
    controller: CalendarSideBarController,
    transclude: true,
    bindings: {
        visible: '<',
        onClose: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-side-bar/calendar-side-bar.cmpt.js